import connect from '@elab/core/store/connect';

import FormButton from './FormButton';
import actions from './Form/redux/actions';

export class WizardReset extends FormButton {
    submit() {
        this.dispatchEvent(new CustomEvent('RESET_DATA'));
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    RESET_DATA: () => {
        dispatch(actions.initialize(ctx.storeName));
    },
});

export default () =>
    customElements.define('e2-wizard-reset', connect(null, mapDispatchToEvents)(WizardReset));
